export const GET_LOCATION = "GET_LOCATION";
export const ADD_LOCATION = "ADD_LOCATION";
